
import { isEmailValid, isPhoneValid, isNameValid, isNotEmpty } from '@/utils/validationRules';

export const validateName = (name: string, fieldName: string = "Name", minLength: number = 2): string | undefined => {
  const trimmedName = name.trim();
  if (!isNotEmpty(trimmedName)) {
    return `${fieldName} is required`;
  }
  
  if (!isNameValid(trimmedName, minLength)) {
    return `${fieldName} must be at least ${minLength} characters`;
  }
  
  return undefined;
};

export const validateEmail = (email: string): string | undefined => {
  const trimmedEmail = email.trim();
  // Check for emptiness first, as isEmailValid might assume non-empty for its regex
  if (!isNotEmpty(trimmedEmail)) { 
    return 'Email is required';
  }
  
  if (!isEmailValid(trimmedEmail)) {
    return 'Please enter a valid email address';
  }
  
  return undefined;
};

export const validatePhone = (phone: string): string | undefined => {
  const trimmedPhone = phone.trim();
  // Phone might be optional in some contexts, but if provided, it should be valid.
  // The isPhoneValid function itself handles the regex check.
  // If the field is truly optional and an empty string is allowed, this check might change.
  // For now, if it's not empty, it must be valid.
  if (!isNotEmpty(trimmedPhone)) {
    // If phone is optional and allowed to be empty, return undefined.
    // If it's required, this utility might not be the place for that check, Zod schema handles "required".
    // Assuming this util is for format check if a value IS present.
    return undefined; // Or handle optionality based on where this is called.
                     // The Zod schema (phoneFieldSchema) makes it required.
                     // This standalone util is for immediate feedback, so if empty, no format error.
  }
  
  if (!isPhoneValid(trimmedPhone)) {
    return 'Please enter a valid phone number';
  }
  
  return undefined;
};
